<template>
  <button @click="login()" type="button" class="w3-button w3-text-theme">
    <font-awesome-icon :icon="['fal', 'sign-in-alt']" />  <span> {{text}}</span>
  </button> 
</template>

<script>
  import LoginButton from "./LoginButton.ts";

  export default LoginButton;
</script>
